import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss'],
})
export class InputComponent implements OnInit {
  @Input() control!: FormControl;
  @Input() iconName: string | undefined;
  @Input() label: string | undefined;
  @Input() placeholder: string = '';
  @Input() isMarkedAsRequired: boolean = false;
  @Input() inputType: string = 'text';

  constructor() {}

  ngOnInit() {
    return;
  }
}
